import BootstrapVue from "bootstrap-vue";
import Vue from "vue";

import {
    CartImage, CvvModal, Logo, PromotionFooter, ShoppingCart, UpsellProductModals, ValFormInput,
    ValSummary
} from "@/components";
import { errorLog } from "@/logging";
import { configureValidation } from "@/validation";
import { LoadingDirective } from "@everbright/promotions";

export default function configureVue(): void {
    configureValidation();

    // Raygun error logging:
    Vue.config.errorHandler = (err: Error, vm: Vue, info: string): void => {
        errorLog.send(err, vm, info);

        if (err) {
            // eslint-disable-next-line no-console
            console.error(err);
        } else if (info) {
            // eslint-disable-next-line no-console
            console.error(info);
        }

        vm.$root.$emit("error");
    };

    Vue.use(BootstrapVue);

    addFilters();
    addDirectives();
    addComponents();
}

function addFilters(): void {
    Vue.filter("currency", (val: number | null) => {
        if (!val) {
            return "";
        }

        const formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2
        });

        return formatter.format(val);
    });
}

function addDirectives(): void {
    Vue.directive("loading", LoadingDirective);
}

function addComponents(): void {
    // Note: we need to explicitly register each component
    // with the tag name so that the names are correct in a production/minified build
    Vue.component("val-form-input", ValFormInput);
    Vue.component("val-summary", ValSummary);
    Vue.component("promotion-footer", PromotionFooter);
    Vue.component("shopping-cart", ShoppingCart);
    Vue.component("cart-image", CartImage);
    Vue.component("cvv-modal", CvvModal);
    Vue.component("upsell-product-modals", UpsellProductModals);
    Vue.component("logo", Logo);
}
